import { render, staticRenderFns } from "./custom-file-transfer.modal.vue?vue&type=template&id=32367245&"
import script from "./custom-file-transfer.modal.vue?vue&type=script&lang=js&"
export * from "./custom-file-transfer.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports